import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, Form, Card, Modal, Col, Row, ProgressBar, Alert, Accordion } from 'react-bootstrap';
import { Table, Segment, Header } from "semantic-ui-react";
import Amplify, { Auth, Storage, API } from 'aws-amplify';
import fastaParser from './FastaJS';
import { message, Typography } from 'antd';
import { store } from 'xijs';

function AF_Submission() {

	Date.prototype.format = function (fmt) {
		var o = {
			"M+": this.getMonth() + 1,                   //月份
			"d+": this.getDate(),                        //日
			"h+": this.getHours(),                       //小时
			"m+": this.getMinutes(),                     //分
			"s+": this.getSeconds(),                     //秒
			"q+": Math.floor((this.getMonth() + 3) / 3), //季度
			"S": this.getMilliseconds()                  //毫秒
		};

		//  获取年份 
		// ①
		if (/(y+)/i.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
		}

		for (var k in o) {
			// ②
			if (new RegExp("(" + k + ")", "i").test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
			}
		}
		return fmt;
	}

	const [user, setUser] = useState(null);
	const [email, setEmail] = useState(null);
	const [warning, setWarning] = useState(null);
	const [path, setPath] = useState(null);
	const [show_e1, setShow_e1] = useState(false);
	const [disable, setDisable] = useState(true);
	const [disable_af, setDisable_af] = useState(true);
	const [disable_op, setDisable_op] = useState(true);

	const [add, setAdd] = useState("No");
	const [fastaCount, setFastaCount] = useState();
	const [fileAF, setFileAF] = useState();
	const [UID, setUID] = useState();
	const [timeStamp, setTimeStamp] = useState();

	const [isLoading, setIsLoading] = useState();

	var Path;

	const Bucket = "s3://p450-result-prod/public/";

	function handleUser(e) {
		let currentuser = e.target.value;
		setUser(currentuser);
	}

	function emailCheck(emailAddr) {
		if ((emailAddr == null) || (emailAddr.length < 2)) return false;

		// 需出现'@',且不在首字符.
		var aPos = emailAddr.indexOf("@", 1);

		if (aPos < 0) {
			return false;
		}

		// '@'后出现'.',且不紧跟其后.
		if (emailAddr.indexOf(".", aPos + 2) < 0) {
			return false;
		}

		return true;
	}

	function handleEmail(e) {
		let currentEmail = e.target.value;
		var isEmail = emailCheck(currentEmail);
		console.log(isEmail);
		if (!isEmail) {
			setWarning('Incorrect Email');
			setShow_e1(true);
			setDisable_op(true);
			console.log('Incorrect Email');

		} else {
			setEmail(currentEmail);
			setShow_e1(false);
			setDisable_op(false);
		}

	}

	function handleFile_af() {
		let ts = new Date();
		setTimeStamp(ts);
		let filenameAF = ts.valueOf() + "/" + "Boltz-P450-" + ts.valueOf() + ".fasta";
		let currentID = "Boltz-P450-" + ts.valueOf();
		setUID(currentID);

		var reader = new FileReader();
		reader.readAsText(fileAF);
		reader.onload = function () {
			// console.log(this.result);
			let check = checkFastaFile(this.result);
			if (check) {
				Storage.put(filenameAF, fileAF, {
					progressCallback(progress) {
						var percentage = (progress.loaded / progress.total * 100).toFixed(1);
						console.log(percentage);
					}
				})
					.then(result => {
						console.log(result);
						Path = Bucket + filenameAF;
						setPath(Path);
						console.log(Path);
						setDisable_af(false);
						setTimeout(() => {
							message.success({ content: 'Protein sequence file upload completed', style: { marginTop: '40vh' } });
							// setDisable_submit(false);
						}, 500);
					})
					.catch(err => {
						console.log(err);
					});
			} else {
				alert("Not FASTA format.");
			}
		}


	}

	function checkFile(params) {
		setFileAF(params.target.files[0]);
		const reader = new FileReader();
		reader.readAsText(params.target.files[0]);
		reader.onload = function (e) {
			// console.log(e.target.result);
			const current = e.target.result;
			let arr_1 = current.replaceAll("\n", "&@%$\n").split("\n");
			var count_sequence = 0;
			if (current.startsWith(">")) {
				for (let i = 0; i < arr_1.length; i++) {
					if (arr_1[i].startsWith(">") && arr_1[i].endsWith("&@%$")) {
						count_sequence++;
					}
				}
				setFastaCount(count_sequence);

			} else {
				setFastaCount(0);
			}
		};
	}

	function checkFastaFile(params) {

		if (params.startsWith(">")) {
			let props = params.replaceAll("\r", "");
			var options = {
				'definition': 'gi|accession|description',
				'delimiter': '|'
			};

			var fasta = new fastaParser(options);

			let currentArr = fasta.parse(props);
			// console.log(currentArr);
			for (let i = 0; i < currentArr.length; i++) {
				if (currentArr[i].sequence.replaceAll("\n", "").endsWith("*")) {
					if (currentArr[i].sequence.replaceAll("\n", "").slice(0, -1).match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g)) {
						// console.log("mark:", currentArr[0].sequence.replaceAll("\n", "").match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g));
						console.log("Not FASTA FORMAT");
						return false;
					}
				} else {
					if (currentArr[i].sequence.replaceAll("\n", "").match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g)) {
						// console.log("mark:", currentArr[0].sequence.replaceAll("\n", "").match(/[^ARNDCQEGHILKMFPSTWXYVUOBZJarndcqeghikmfpstwxyvuobzj]/g));
						console.log("Not FASTA FORMAT");
						return false;
					}
				}

			}

			return true

		} else {
			console.log("Not FASTA FORMAT");
			return false;
		}
	}

	useEffect(() => {
		if (fastaCount !== undefined) {
			if (fastaCount === 0) {
				alert("File Error.");
			} else if (fastaCount > 10) {
				alert("Too many sequences.");
			} else {
				handleFile_af();
			}
		}
	}, [fastaCount])


	function saveParams(param1, param2) {
		let inFifteenMinutes = new Date(new Date().getTime() + 24 * 3600 * 1000 * 30);   //  30 days
		store.set(param1, param1, inFifteenMinutes);
	}



	function handleSubmit_af() {

		setIsLoading(true);
		let current = {
			"Name": fileAF.name,
			"ID": UID,
			"Hem": add,
			"Timestamp": timeStamp.valueOf(),
			"Number": fastaCount,
			"Status": "Queued"
		};
		console.log(current);

		async function postAF() {
			// Amplify.Logger.LOG_LEVEL = "DEBUG";

			const session = await Auth.currentCredentials();
			console.log(session)
			const apiRequest = {
				body: {
					"Username": user,
					"Email": email,
					"Number": fastaCount,
					"Name": fileAF.name,
					"Type": "AlphaFold-P450",
					"Timestamp": timeStamp.valueOf(),
					"ID": UID,
					"Hem": add,
					"Sequence_s3_path": path

				},
				headers: {
					"Content-Type": "application/json",

				},
			};

			return await API
				.post("P450", "/alphafold2", apiRequest)
				.then(
					(data) => {
						console.log(data);
						saveParams(UID, current);
						setIsLoading(false);
						setTimeout(
							() => {
								window.location.href = "/results";
							},
							3000
						);
					},
					(error) => {
						console.log(error);
						alert("Network Error!");
						window.location.href = "/submit";
					}
				);
		};
		postAF();
	}

	useEffect(() => {
			if (path !== undefined && user !== null && email !== null) {
				setDisable(false);
			} else {
				setDisable(true);
			}
		}, [path, user, email]);

	return (
		<div style={{
			background: "#FFFFFF"

		}}>

			<Row>
				<Col>
				</Col>
				<Col md={10}>

					<div style={{

						height: "50px"
					}}>
					</div>
					<div>


						<Card>
							<Card.Header>
								<Accordion.Toggle as={Header} eventKey="1" textAlign='center'>
									<span style={{ color: "#6495ED" }} >P450 Boltz</span>
								</Accordion.Toggle>
							</Card.Header>
							<Card.Body>
								<Alert show={show_e1} variant="warning" onClose={() => setShow_e1(false)} dismissible>
									<Alert.Heading>Warning</Alert.Heading>
									<p>{warning}</p>
								</Alert>

								<div style={{ margin: "25px 200px 25px 200px" }}>
									<Typography.Paragraph italic style={{ textAlign: "justify" }}><blockquote>Perform structural modeling of the user-submitted sequence using Boltz.</blockquote></Typography.Paragraph>
								</div>
								<Form>
									<Form.Group as={Row} controlId="formBasicUserName">

										<Form.Label column sm="3" style={{ textAlign: "right" }}>
											User Name:
										</Form.Label>
										<Col sm="8">
											<Form.Control type="text" placeholder="User Name" onChange={handleUser} />
										</Col>


									</Form.Group>

									<Form.Group as={Row} controlId="formBasicEmail">

										<Form.Label column sm="3" style={{ textAlign: "right" }}>
											Email:
										</Form.Label>

										<Col sm="8">
											<Form.Control type="email" placeholder="Email" onChange={handleEmail} />
										</Col>

									</Form.Group>

									<Form.Group as={Row} controlId="formBasicEmail">

										<Form.Label column sm="3" style={{ textAlign: "right" }}>
											Protein sequences:
										</Form.Label>

										<Col sm="8">
											<Form.File id="exampleFormControlFile1" onChange={checkFile} accept=".fasta" />
											<Form.Text className="text-muted">Max Length: 10 sequences</Form.Text>
										</Col>

									</Form.Group>

									<Form.Group as={Row} controlId="formBasicEmail">

										<Form.Label column sm="3" style={{ textAlign: "right" }}>
											Add HEM:
										</Form.Label>

										<Col sm="8">
											<Form.Check
												type="radio"
												inline
												label="Yes"
												name="formHorizontalRadios"
												id="formHorizontalRadios1"
												onChange={() => setAdd("Yes")}
											/>
											<Form.Check
												type="radio"
												inline
												label="No"
												name="formHorizontalRadios"
												id="formHorizontalRadios2"
												defaultChecked
												onChange={() => setAdd("No")}
											/>
										</Col>

									</Form.Group>

									<div style={{ textAlign: "center" }}>
										<Button
											variant="outline-primary"
											disabled={disable || isLoading}
											onClick={!isLoading ? handleSubmit_af : null}

										>
											{isLoading ? 'PROCESSING' : 'SUBMIT'}
										</Button>
									</div>

									<Row>
										<Col sm="3"></Col>
										<Col sm="8">
											<Form.Text className="text-muted">
												Note: Per email can only submit 3 tasks per day.
											</Form.Text>
										</Col>

									</Row>

								</Form>
							</Card.Body>
						</Card>

					</div>


					<div style={{

						height: "50px"
					}}>
					</div>
				</Col>
				<Col>
				</Col>
			</Row>
		</div>

	);
}

export default AF_Submission;